import { useState } from 'react';
import { Sun, Moon } from 'lucide-react';
import { useStore } from '@tanstack/react-store'
import { themeStore, setDarkMode } from '../../stores/theme'
import { useNavigate } from 'react-router-dom';
import { logoColor, logoLight, dummyUser } from '../ui/media';

function AuthHeader() {
    const { isDarkMode } = useStore(themeStore)
    const [navOpen, setNavOpen] = useState(false);
    const navigate = useNavigate()
    
    const toggleTheme = () => {
        setDarkMode(!isDarkMode);
    };

    const toggleNav = () => {
        setNavOpen(!navOpen);
    };

    return (
        <header className={`w-full m-0 fixed ${isDarkMode ? "bg-[rgba(255,255,255,0.6)] border-b border-white-200" : "bg-white border-b border-gray-200"}  flex items-center justify-between shadow-sm z-10 px-16`}>
            <div className="absolute z-99 top-4 right-4">
                <button
                    onClick={toggleTheme}
                    className={`p-2 rounded-full ${isDarkMode ? 'bg-gray-800 text-yellow-400' : 'bg-white text-gray-800 shadow'}`}>
                    {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
                </button>
            </div>
            <div className="container px-4 py-3 flex justify-between items-center">
                <div className="flex items-center">
                    <img
                        onClick={() => navigate('/lander')} 
                        className="h-12 cursor-pointer" 
                        src={`${isDarkMode ? logoLight : logoColor}`} 
                        alt="Logo" 
                    />
                </div>
                <button onClick={toggleNav} className="md:hidden text-white">
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
                    </svg>
                </button>
                <nav className={`absolute md:relative top-full left-0 w-full md:w-auto md:bg-transparent p-4 md:p-0 transform ${navOpen ? 'scale-y-100' : 'scale-y-0 md:scale-y-100'} origin-top transition-transform md:flex md:items-center`}>
                    <ul className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6">
                        {[{
                            name: 'Home',
                            url: '/lander'
                        }, {
                            name: 'About Us',
                            url: '/lander#about'
                        }, {
                            name: 'Services',
                            url: '/lander#services',
                        }, {
                            name: 'Subscriptions',
                            url: '/subscriptions',
                        }, {
                            name: 'FAQ',
                            url: '/lander#faq'
                        }, {
                            name: 'Contact Us',
                            url: '/lander#contact'
                        }].map((item, index) => (
                            <li key={index}><a href={`${item.url}`} className={`text-gray-800`}>{item?.name}</a></li>
                        ))}
                    </ul>
                    <button
                        onClick={() => navigate('/login')}
                        className="mt-4 md:mt-0 md:ml-6 bg-blue-600 text-white px-5 py-1 rounded-full font-medium">
                        Log In
                    </button>
                </nav>
            </div>
        </header>
    );
}
export default AuthHeader;